import React from 'react';
import { Card } from '@/components/shadcn/card';
import { cn } from '@/utils/styles';

interface InputCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'light';
}

const InputCard = ({
  title,
  description,
  children,
  className,
  variant = 'default',
}: InputCardProps) => {
  return (
    <Card
      className={cn(
        'flex w-full flex-col gap-4 bg-neutral-900 p-8',
        {
          'bg-neutral-800': variant === 'light',
        },
        className,
      )}>
      <div className="flex w-full flex-col gap-2">
        <h3 className={cn('text-base font-semibold')}>{title}</h3>
        <p className="text-xs text-neutral-300">{description}</p>
      </div>
      {children}
    </Card>
  );
};

export default InputCard;
